var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"bg"}},[_c('div',{staticClass:"hero-text"},[_c('h1',[_vm._v("Novas Ignaras Gambiarras")]),_c('md-button',{staticClass:"md-accent md-raised md-primary",attrs:{"to":"/"}},[_vm._v("Apertar")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }